<donut-slack-preview class="fc-g1" :message="`${introMessage}
&gt;&gt;&gt;${promptExample}`"></donut-slack-preview>